(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alp-announcebar-flash-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-flash-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-flash-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // close alp-announcebar-flash-close-btn
    document.querySelectorAll('.alp-announcebar-flash-close-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.parentElement.style.display = 'none';
      });
    });
    // get height
    AlpFn.GetTheHeight('.alp-announcement-bar-flash-section', 'flash-bar');
    setInterval(() => {
      AlpFn.GetTheHeight('.alp-announcement-bar-flash-section', 'flash-bar');
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcebar-flash"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-flash-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-flash-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // close alp-announcebar-flash-close-btn
    document.querySelectorAll('.alp-announcebar-flash-close-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.parentElement.style.display = 'none';
      });
    });
    // get height
    AlpFn.GetTheHeight('.alp-announcement-bar-flash-section', 'flash-bar');
    setInterval(() => {
      AlpFn.GetTheHeight('.alp-announcement-bar-flash-section', 'flash-bar');
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcebar-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-3-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-3-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-combo-sale-list-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // alp-combo-sale-list-item-gifts-content active product
    $('.alp-combo-sale-list-item-gifts-content > div').click(function () {
      let $this = $(this);
      $this.addClass('active').siblings().removeClass('active');
      //
      let $price = $this.attr('data-price');
      let $product_price = $this.attr('data-product-price');
      $('.alp-combo-sale-list-item-gifts-price').find('span.final-price').text($price);
      $('.alp-combo-sale-list-item-gifts-price').find('span.original-price-value').text($product_price);
      //
      let $coupon_code = $this.attr('data-coupon-code');
      navigator.clipboard
        .writeText($coupon_code)
        .then(() => {
          const notification = $this.find('.copyNotification');
          notification.stop().slideDown(300);
          setTimeout(() => {
            notification.stop().slideUp(200);
          }, 5000);
        })
        .catch((err) => {});
    });
    //
    $('.combo-add-to-cart-button').on('click', async function () {
      let $this = $(this);
      let $parent = $this.parents('.alp-combo-sale-list-item');
      let variants = '';
      $parent.find('[data-active-variant].active').each(function () {
        variants += $(this).attr('data-active-variant') + ',';
      });
      variants = variants.slice(0, -1);
      $this.addClass('adding');
      await AlpFn.AddToCartOne(variants, 1);
      await AlpFn.refreshCart('[data-ajax-cart]');
      $this.removeClass('adding');
      document.body.classList.add('cart-open');
      setTimeout(() => {
        $('[data-ajax-cart]').addClass('open');
        document.body.classList.add('noscroll');
      }, 50);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-combo-sale-select-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // popup open
    $('.alp-combo-sale-select-product-main-trigger').click(function () {
      let $this = $(this);
      let $popup = $this.parents('.alp-section').find('.alp-combo-sale-select-product-main-selector-popup');
      $popup.addClass('active');
    });
    // popup close
    $(
      '.alp-combo-sale-select-product-main-selector-inner-header-close, .alp-combo-sale-select-product-main-selector-popup-bg'
    ).click(function () {
      let $this = $(this);
      let $popup = $this.parents('.alp-combo-sale-select-product-main-selector-popup');
      $popup.removeClass('active');
    });
    //
    $('.alp-product-item-xx-selector-add').click(function () {
      let $this = $(this);
      let $popup = $this.parents('.alp-combo-sale-select-product-main-selector-popup');
      let $parent = $this.parents('.alp-product-item-xx-selector');
      let $product_id = $parent.attr('data-product-id');
      //
      let $target_wrapper = $parent.parents('.alp-section').find('.alp-combo-sale-select-product-main-wrapper-inner');
      $target_wrapper
        .find(`.alp-combo-sale-select-product-main:not(.active)`)
        .eq(0)
        .addClass('active')
        .find(`[data-product-id="${$product_id}"]`)
        .addClass('active');

      $popup.removeClass('active');
      let $target_active_length = $target_wrapper.find('.alp-combo-sale-select-product-main.active').length;
      if ($target_active_length >= 1) {
        $target_wrapper
          .parents('.alp-combo-sale-select-content')
          .find('.alp-combo-sale-select-bottom')
          .addClass('active');
      }
      if ($target_active_length >= 2) {
        $target_wrapper.addClass('active');
        $target_wrapper.parents('.alp-combo-sale-select-content').addClass('active');
        // $target_wrapper.parents('.alp-combo-sale-select-content').find(`[data-combo-gift]`).addClass('active');
        $target_wrapper
          .parents('.alp-combo-sale-select-content')
          .find('.alp-combo-sale-select-product-gift')
          .addClass('active');
      }
    });
    // remove product
    $('.alp-product-item-xx-select-remove').click(function () {
      let $this = $(this);
      let $parent = $this.parents('.alp-product-item-xx-select');
      let $target_wrapper = $parent.parents('.alp-section').find('.alp-combo-sale-select-product-main-wrapper-inner');
      $parent.removeClass('active');
      $parent.parents('.alp-combo-sale-select-product-main').removeClass('active');
      $target_wrapper.removeClass('active');
      $target_wrapper.parents('.alp-combo-sale-select-content').removeClass('active');
      $parent
        .parents('.alp-combo-sale-select-content')
        .find('.alp-combo-sale-select-product-gift')
        .removeClass('active');
      let $target_active_length = $target_wrapper.find('.alp-combo-sale-select-product-main.active').length;
      if ($target_active_length == 0) {
        $target_wrapper
          .parents('.alp-combo-sale-select-content')
          .find('.alp-combo-sale-select-bottom')
          .removeClass('active');
      }
    });
    // gift select trigger
    $('.alp-combo-sale-select-product-gift > div.active').each(function () {
      let $this = $(this);
      let $parent = $this.parent();
      if ($parent.hasClass('active')) {
        let $free_text = $this.attr('data-free-text');
        $('[data-combo-gift]').find('.final-price').text($free_text).addClass('active');
      }
    });
    $('.alp-combo-sale-select-product-gift > div[data-coupon-code]').click(function () {
      let $this = $(this);
      let $parent = $this.parent();
      if ($parent.hasClass('active')) {
        $this.addClass('active').siblings().removeClass('active');
        let $free_text = $this.attr('data-free-text');
        $('[data-combo-gift]').find('.final-price').text($free_text).addClass('active');
      }
      let $coupon_code = $this.attr('data-coupon-code');
      navigator.clipboard
        .writeText($coupon_code)
        .then(() => {
          const notification = $this.find('.copyNotification');
          notification.stop().slideDown(300);
          setTimeout(() => {
            notification.stop().slideUp(200);
          }, 5000);
        })
        .catch((err) => {});
    });
    // function for alp-combo-sale-select-product-main-selector-trigger
    function productMainSelectorTrigger(trigger) {
      let $this = trigger;
      let $parent = $this.parent();
      $parent.toggleClass('active');
    }
    $('.alp-combo-sale-select-product-main-selector-trigger-inner').click(function () {
      productMainSelectorTrigger($(this));
    });

    // selector for product main
    function productMainSelectorItem(selector) {
      let $this = selector;
      let $id = $this.attr('data-product-id');
      let $target_wrapper = $this.parents('.alp-combo-sale-select-product-main');
      $target_wrapper.find(`[data-product-id="${$id}"]`).addClass('active').siblings().removeClass('active');
      let $title = $this.text();
      $target_wrapper.find('.alp-combo-sale-select-product-main-selector-trigger-inner').find('span').text($title);
    }
    $('.alp-combo-sale-select-product-main-selector-item').click(function () {
      productMainSelectorItem($(this));
    });

    // init function for product main selector
    function initProductMainSelector() {
      $('.alp-combo-sale-select-product-main').each(function () {
        let $this = $(this);
        let $id = $this.find('[data-product-id].active').attr('data-product-id');
        let $title = $this.find(`.alp-combo-sale-select-product-main-selector-item[data-product-id="${$id}"]`).text();
        $this.find('.alp-combo-sale-select-product-main-selector-trigger-inner span').text($title);
      });
    }
    initProductMainSelector();

    //
    function calcPrice() {
      let $usd = '$';
      let $total_price = 0;
      let $total_original_price = 0;
      let $target_wrapper = $('.alp-combo-sale-select-content');
      let $active_main_products = $target_wrapper.find('.alp-combo-sale-select-product-main.active');
      let $active_gift_product = $target_wrapper.find('.alp-combo-sale-select-product-gift.active');
      let $additional_products = $target_wrapper.find('.alp-product-promotion-new-2-item-2');
      $active_main_products.each(function () {
        let $this = $(this);
        $total_price += Number(
          $this.find(`[data-product-id].active .price_with_variants_item.active`).attr('data-price')
        );
        $total_original_price += Number(
          $this.find(`[data-product-id].active .price_with_variants_item.active`).attr('data-original-price')
        );
      });
      $active_gift_product.each(function () {
        let $this = $(this);
        if ($this.children(`.active`).length > 0) {
          let $final_price = Number($this.children(`.active`).attr('data-price'));
          if ($final_price < 0) {
            $total_price = $total_price - Math.abs($final_price);
          } else {
            $total_price = $total_price + $final_price;
          }
          $total_original_price += Number($this.children(`.active`).attr('data-original-price'));
        }
      });
      $target_wrapper.find('.alp-combo-sale-select-line-item[data-combo-additional]').html('');
      $additional_products.each(function () {
        let $this = $(this);
        let $quantity_input = $this.find(`input.quantity__input[type=number]`);
        $total_price += Number($this.attr('data-price')) * Number($quantity_input.val());
        $total_original_price += Number($this.attr('data-original-price')) * Number($quantity_input.val());
        // append each item to line item data-combo-additional
        let $price = (Number($this.attr('data-price')) / 100) * Number($quantity_input.val());
        if (Number($quantity_input.val()) > 0) {
          $target_wrapper.find('.alp-combo-sale-select-line-item[data-combo-additional]').append(`
            <div class="alp-combo-sale-select-line-item-additional">
              <span>${$this
                .find('.alp-product-promotion-new-2-i-title-2 .promotion-new-item-title-text .headline__h6')
                .text()} x ${Number($quantity_input.val())}</span>
              <span class="final-price">${$usd}${$price.toFixed(2)}</span>
            </div>
          `);
        }
      });
      $total_original_price = $total_original_price / 100;
      $total_price = $total_price / 100;
      $target_wrapper
        .find('.alp-combo-sale-select-total-price')
        .find('.original-price')
        .html($usd + $total_original_price.toFixed(2));
      $target_wrapper
        .find('.alp-combo-sale-select-total-price')
        .find('.final-price')
        .html($usd + $total_price.toFixed(2));
    }
    setInterval(function () {
      calcPrice();
    }, 1000);

    //
    async function addToCartAndCheckout(button) {
      let $this = button ? button : $('.alp-combo-sale-select-checkout-button .alp-button');
      let $data = [];
      let $wrapper = $this.parents('.alp-combo-sale-select-content');
      $wrapper.find('.alp-combo-sale-select-product-main.active').each(function () {
        let $this = $(this);
        let $variant_id = $this.find(`[data-active-variant].active`).attr('data-active-variant');
        let $multi_add_cart = $this.find(`[data-active-variant].active`).find('.bundle_add_selector.selected');
        $data.push({ id: $variant_id, quantity: 1 });
        if ($multi_add_cart.length > 0) {
          $multi_add_cart.each(function () {
            $data.push({ id: $(this).attr('data-multi-add-cart-id'), quantity: 1 });
          });
        }
      });
      $wrapper.find('.alp-combo-sale-select-product-gift.active').each(function () {
        let $this = $(this);
        if ($this.find(`[data-product-id].active`).length > 0) {
          let $variant_id = $this.find(`[data-product-id].active`).attr('data-active-variant');
          $data.push({ id: $variant_id, quantity: 1 });
        }
      });
      $wrapper.find('.alp-combo-sale-select-additional-products-item').each(function () {
        let $this = $(this);
        let $variant_id = $this.find(`.alp-product-promotion-new-2-item-2`).attr('data-active-variant');
        let $quantity = Number($this.find(`input.quantity__input[type=number]`).val());
        if ($quantity > 0) {
          $data.push({ id: $variant_id, quantity: $quantity });
        }
      });
      console.log($data);
      $this.addClass('adding');
      await fetch(Shopify_Url + 'cart/clear.js', {
        method: 'POST',
      });
      await AlpFn.AddToCartMulti($data);

      // apply coupon code
      //   let $coupon_code = $wrapper
      //     .find('.alp-combo-sale-select-product-gift.active > div.active')
      //     .attr('data-coupon-code');
      //   if ($coupon_code) {
      //     window.discountOnCartProApp.applyCode($coupon_code);
      //   }
      // refresh cart
      await AlpFn.refreshCart('[data-ajax-cart]');
      $this.removeClass('adding');
      document.body.classList.add('cart-open');
      setTimeout(() => {
        $('[data-ajax-cart]').addClass('open');
        document.body.classList.add('noscroll');
      }, 50);
      // trigger checkout button
      //   $(`.alp-checkout-buttons .alp-button[type="submit"][value="Checkout"]`).trigger('click');
    }
    //
    $('.alp-combo-sale-select-checkout-button .alp-button').click(function () {
      addToCartAndCheckout($(this));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-global-compare-full"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
    class GlobalCompare {
      // checkbox : .global-compare-checkbox with [data-product-id]
      // trigger : [data-global-compare-open] with [data-global-compare-open=' product.id ']
      // options selector : .global-compare-selector
      // options : .global-compare-options with [data-product-id]
      // floating tab: .global-compare-floating-tab

      constructor() {
        // 存储事件处理函数
        this.checkboxs = [];
        this.eventListeners = new Map();
        this.compareParent = document.querySelector('.global-compare');
        this.floatingTab = document.querySelector('.global-compare-floating-tab');
        this.init();
      }

      init() {
        this.removePreloadProducts();
        this.triggerSelectOpen();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.hanldeSelectorChange();
        this.findTheItemsDiff();
        this.triggerOpen();
        this.triggerCompareCheckboxInit();
        this.updateFlotingTabStatus(this.getCookie());
        this.clickFlotingTab();
        window.addEventListener('resize', () => this.setSameHeightForItems());
        window.addEventListener('CompareTrigger', () => this.checkboxEventUpdate());
        this.compareParent.querySelector('.global-compare-diff-trigger').addEventListener('click', () => {
          this.compareParent.classList.toggle('show_diff');
          this.setSameHeightForItems();
        });
      }

      triggerSelectOpen() {
        const globalCompareSelector = document.querySelector('.global-compare-selector span');
        const globalCompareOptions = globalCompareSelector
          .closest('.global-compare-selector')
          .querySelector('.global-compare-options');
        globalCompareSelector.addEventListener('click', () => {
          globalCompareOptions.classList.toggle('hidden');
        });
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.global-compare-selector')) {
            globalCompareOptions.classList.add('hidden');
          }
        });
      }

      updateSelectedProduct() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.classList.remove('selected');
        });
        options.forEach((option) => {
          const productId = option.dataset.productId;
          const productEl = this.compareParent.querySelector(
            `.products-new-compare-wrapper [data-product-id="${productId}"]`
          );
          if (productEl) option.classList.add('selected');
        });
      }

      setSameHeightForItems() {
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx_compare_spec_list'
        );
        const items = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        // 重置高度
        rows.forEach((row) => {
          row.querySelectorAll('.axx_compare_spec_list_item').forEach((item) => {
            item.style.setProperty('--height', 'auto');
          });
        });
        // 设置规格高度
        items.forEach((_, index) => {
          let maxHeight = 0;
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            maxHeight = Math.max(maxHeight, item.offsetHeight);
          });
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            item.style.setProperty('--height', `${maxHeight}px`);
          });
        });
        // 设置图片高度
        const imageWrappers = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx-images-with-swatch'
        );
        const maxImageHeight = Math.max(...[...imageWrappers].map((img) => img.offsetHeight), 0);
        imageWrappers.forEach((img) => img.style.setProperty('--height', `${maxImageHeight}px`));
      }

      hanldeSelectorChange() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.addEventListener('click', () => {
            const productId = option.dataset.productId;
            option.classList.toggle('selected');
            option.classList.contains('selected') ? this.addProduct(productId) : this.removeProduct(productId);
          });
        });
      }

      removePreloadProducts() {
        this.compareParent
          .querySelectorAll('.products-new-compare-wrapper .product-new-compare-item[data-product-id]')
          .forEach((el) => el.remove());
      }

      async addProduct(ids) {
        // 处理多id输入并去重
        const idArray = Array.isArray(ids)
          ? ids
          : ids
              .toString()
              .split(',')
              .filter((id) => id.trim() !== '');
        const uniqueIds = [...new Set(idArray)];
        const fetchUrl = this.compareParent.dataset.fetchUrl;
        this.compareParent.classList.add('loading');
        // compare ids and the existing products `.product-new-compare-item[data-product-id="${id}"]`
        const existingProducts = this.compareParent.querySelectorAll('.product-new-compare-item[data-product-id]');
        const existingIds = [...existingProducts].map((el) => el.dataset.productId);
        const newIds = uniqueIds.filter((id) => !existingIds.includes(id));
        if (newIds.length === 0) {
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          return;
        }
        // continue to add products
        try {
          const response = await fetch(fetchUrl);
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceParents = html.querySelectorAll('.products-new-compare-wrapper');
          const targetWrappers = this.compareParent.querySelectorAll('.products-new-compare-wrapper');
          // 遍历每个唯一id添加产品
          uniqueIds.forEach((id) => {
            sourceParents.forEach((sourceEl, index) => {
              const targetEl = targetWrappers[index];
              if (!targetEl) return;
              const exitProductEl = targetEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              // if (exitProductEl) exitProductEl.remove();
              if (exitProductEl) return;
              const productEl = sourceEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              if (productEl) targetEl.appendChild(productEl);
              const removeEl = productEl.querySelector('.product-compare-remove');
              if (removeEl) this.handleRemoveProductTrigger(removeEl);
            });
          });
        } finally {
          this.findTheItemsDiff();
          this.updateSelectedProduct();
          this.setSameHeightForItems();
          if (window.axxVariantsSwatch) window.axxVariantsSwatch.update();
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          this.setCookie();
          this.updateCheckboxStatus();
        }
      }

      removeProduct(id) {
        this.compareParent
          .querySelectorAll(`.products-new-compare-wrapper [data-product-id="${id}"]`)
          .forEach((el) => el.remove());
        this.findTheItemsDiff();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.setCookie();
        this.updateCheckboxStatus();
      }

      handleRemoveProductTrigger(el) {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = el.closest('.product-new-compare-item');
          const productId = parent.dataset.productId;
          this.removeProduct(productId);
        });
      }

      setCookie() {
        const uniqueIds = [];
        this.compareParent
          .querySelectorAll('.global-compare-option.selected')
          .forEach((el) => uniqueIds.push(el.dataset.productId));
        // 存储id到cookie（30天过期）
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${uniqueIds.join(',')}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(`${uniqueIds.join(',')}`);
      }

      getCookie() {
        // let presetIds = this.compareParent.dataset.presetProducts;
        const cookieValue =
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('selectedIds='))
            ?.split('=')[1] || '';
        if (cookieValue) {
          return cookieValue;
        }
      }

      addIdToCookie(id) {
        let ids = this.getCookie();
        if (!ids) {
          ids = id;
        } else {
          ids = `${ids},${id}`;
        }
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(ids);
      }

      removeIdFromCookie(id) {
        let ids = this.getCookie();
        if (ids) {
          ids = ids
            .split(',')
            .filter((i) => i !== id)
            .join(',');
          const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
          this.updateFlotingTabStatus(ids);
        }
      }

      findTheItemsDiff() {
        document
          .querySelectorAll(
            '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list .axx_compare_spec_list_item'
          )
          .forEach((item) => {
            item.classList.remove('diff');
          });
        const allRows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list'
        );
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data [data-product-id] .axx_compare_spec_list'
        );
        const firstRowItems = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        firstRowItems.forEach((_, index) => {
          const values = [...rows].map(
            (row) => row.querySelectorAll('.axx_compare_spec_list_item')[index]?.querySelector('.axcp-desc').textContent
          );
          const hasDiff = new Set(values).size > 1;
          if (hasDiff) {
            allRows.forEach((row) => {
              row.querySelectorAll('.axx_compare_spec_list_item')[index].classList.add('diff');
            });
          }
        });
      }

      triggerCompareCheckboxInit() {
        this.checkboxs = document.querySelectorAll('.global-compare-checkbox');
        if (this.checkboxs.length > 0) {
          this.updateCheckboxStatus();
          this.checkboxs.forEach((checkbox) => {
            const handler = (e) => this.checkboxToggle(checkbox);
            this.eventListeners.set(checkbox, handler);
            checkbox.addEventListener('click', handler);
          });
        }
      }

      checkboxEventUpdate() {
        this.checkboxs.forEach((checkbox) => {
          const handler = this.eventListeners.get(checkbox);
          if (handler) {
            checkbox.removeEventListener('click', handler);
          }
        });
        this.triggerCompareCheckboxInit();
      }

      checkboxToggle(checkbox) {
        const productId = checkbox.dataset.productId;
        if (checkbox.classList.contains('checked')) {
          checkbox.classList.remove('checked');
          this.removeIdFromCookie(productId);
        } else {
          this.addIdToCookie(productId);
        }
        this.updateCheckboxStatus();
      }

      updateCheckboxStatus() {
        let ids = this.getCookie();
        // remove class
        this.checkboxs.forEach((checkbox) => {
          checkbox.classList.remove('checked');
        });
        // update classlist
        if (ids) {
          ids.split(',').forEach((id) => {
            this.checkboxs.forEach((checkbox) => {
              let checkboxId = parseInt(checkbox.dataset.productId);
              if (checkboxId == id) {
                checkbox.classList.add('checked');
              }
            });
          });
          this.updateFlotingTabStatus(ids);
        }
      }

      updateFlotingTabStatus(selectedIds) {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        if (selectedIds) {
          const selectedIdsArray = selectedIds.split(',');
          const selectedIdsCount = selectedIdsArray.length;
          if (selectedIdsCount > 0) {
            floatingTab.classList.add('show');
          } else {
            floatingTab.classList.remove('show');
          }
          floatingTab.querySelector('.compare-products-count').textContent = selectedIdsCount;
        } else {
          floatingTab.classList.remove('show');
        }
      }

      clickFlotingTab() {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        floatingTab.addEventListener('click', (e) => {
          e.preventDefault();
          let ids = this.getCookie() ? this.getCookie() : presetIds;
          if (ids) {
            this.addProduct(ids);
            this.compareParent.classList.remove('hidden');
          }
        });
      }

      triggerOpen() {
        const triggers = document.querySelectorAll('[data-global-compare-open]');
        triggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const productId = el.dataset.globalCompareOpen || 'null';
            const productEl = this.compareParent.querySelector(
              `.product-new-compare-item[data-product-id="${productId}"]`
            );
            if (productEl) {
              this.compareParent.classList.remove('hidden');
              this.setSameHeightForItems();
            } else {
              let presetIds = this.compareParent.dataset.presetProducts;
              let ids = this.getCookie() ? this.getCookie() : presetIds;
              if (!ids) {
                ids = productId;
              } else {
                ids = `${ids},${productId}`;
              }
              this.addProduct(ids);
              this.compareParent.classList.remove('hidden');
            }
          });
        });
        const closeTriggers = this.compareParent.querySelectorAll('.global-compare-close, .global-compare-overlay');
        closeTriggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.compareParent.classList.add('hidden');
          });
        });
      }
    }

    window.axxGlobalCompare = new GlobalCompare();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-page-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-product-sticky-banner"] && !Shopify.designMode) return;
  try {
    
  class LXProductStickyBanner extends HTMLElement {
    constructor() {
      super();
      this._syncingQuantity = false;
      this._lastScrollY = window.scrollY;
      this._headerHidden = false;
      this._onScroll = this.handleScroll.bind(this);
      this._onTabClick = this.handleTabClick.bind(this);
      this._onAddToCartClick = this.handleAddToCartClick.bind(this);
      this._onBannerQuantityChange = this.handleBannerQuantityChange.bind(this);
      this._onFormQuantityChange = this.handleFormQuantityChange.bind(this);
      this._onProductDetailUpdated = this.handleProductDetailUpdated.bind(this);
      this._onFormLoadingChange = this.handleFormLoadingChange.bind(this);
      this._syncTopHeight = this.syncTopHeight.bind(this);
    }

    connectedCallback() {
      this.productDetailEl = document.querySelector('[data-product-detail]');
      this.productFormEl = document.querySelector('form.lx-product-form');
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.addToCartBtn = this.querySelector('[data-product-sticky-banner-add-to-cart]');

      this.querySelectorAll('.lx-product-sticky-banner__tab[data-target]').forEach((tab) => {
        tab.addEventListener('click', this._onTabClick);
      });

      this.addToCartBtn?.addEventListener('click', this._onAddToCartClick);
      this.bindQuantityListeners();

      this.productDetailEl?.addEventListener(
        'lx-variant-selector-v1:product-detail-updated',
        this._onProductDetailUpdated
      );

      //   this.productFormEl?.addEventListener('submit', this._onFormLoadingChange);
      document.addEventListener('lx-add-to-cart:finished', this._onFormLoadingChange);

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._syncTopHeight);
      this.bindTopHeightObserver();
      this.handleScroll();
      this.syncQuantityFromForm();
    }

    disconnectedCallback() {
      this.querySelectorAll('.lx-product-sticky-banner__tab[data-target]').forEach((tab) => {
        tab.removeEventListener('click', this._onTabClick);
      });

      this.addToCartBtn?.removeEventListener('click', this._onAddToCartClick);
      this.unbindQuantityListeners();

      this.productDetailEl?.removeEventListener(
        'lx-variant-selector-v1:product-detail-updated',
        this._onProductDetailUpdated
      );

      //   this.productFormEl?.removeEventListener('submit', this._onFormLoadingChange);
      document.removeEventListener('lx-add-to-cart:finished', this._onFormLoadingChange);

      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._syncTopHeight);
      this.unbindTopHeightObserver();
      this.setHeaderHidden(false);
    }

    bindTopHeightObserver() {
      this.unbindTopHeightObserver();
      this.topEl = this.querySelector('.lx-product-sticky-banner__top');

      if (!this.topEl) {
        this.syncTopHeight();
        return;
      }

      if (typeof ResizeObserver !== 'undefined') {
        this._topResizeObserver = new ResizeObserver(this._syncTopHeight);
        this._topResizeObserver.observe(this.topEl);
      }

      this.syncTopHeight();
    }

    unbindTopHeightObserver() {
      this._topResizeObserver?.disconnect();
      this._topResizeObserver = null;
    }

    syncTopHeight() {
      const topEl = this.querySelector('.lx-product-sticky-banner__top');
      const sectionEl = this.closest('.shopify-section.lx-product-sticky-banner');

      if (!topEl) {
        this.style.removeProperty('height');
        this.style.removeProperty('--lx-product-sticky-banner-top-height');
        sectionEl?.style.removeProperty('height');
        return;
      }

      const height = Math.ceil(topEl.getBoundingClientRect().height);
      if (height <= 0) return;

      const heightValue = `${height}px`;
      this.style.setProperty('--lx-product-sticky-banner-top-height', heightValue);
      this.style.height = heightValue;
      sectionEl?.style.setProperty('height', heightValue);
    }

    bindQuantityListeners() {
      this.unbindQuantityListeners();
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.bannerQuantityEl?.addEventListener('change', this._onBannerQuantityChange);
      this.bannerQuantityEl?.addEventListener('input', this._onBannerQuantityChange);
      this.formQuantityEl?.addEventListener('change', this._onFormQuantityChange);
      this.formQuantityEl?.addEventListener('input', this._onFormQuantityChange);
    }

    unbindQuantityListeners() {
      this.bannerQuantityEl?.removeEventListener('change', this._onBannerQuantityChange);
      this.bannerQuantityEl?.removeEventListener('input', this._onBannerQuantityChange);
      this.formQuantityEl?.removeEventListener('change', this._onFormQuantityChange);
      this.formQuantityEl?.removeEventListener('input', this._onFormQuantityChange);
    }

    getScrollOffset() {
      return Number(this.dataset.scrollOffset || 32);
    }

    parseCssLength(value) {
      const num = parseFloat(String(value || '').trim());
      return Number.isFinite(num) ? num : 0;
    }

    getCssVar(name) {
      const bodyValue = getComputedStyle(document.body).getPropertyValue(name);
      if (bodyValue) return this.parseCssLength(bodyValue);

      return this.parseCssLength(getComputedStyle(document.documentElement).getPropertyValue(name));
    }

    getHeaderBarOffset() {
      // if (this._headerHidden) return 0;

      const barEl = document.querySelector('.shopify-section.alp-announcement-bar-section');
      const headerEl = document.querySelector('.shopify-section.alp-header-section');
      const barHeight = barEl?.offsetHeight || this.getCssVar('--bar-height');
      const headerHeight = headerEl?.offsetHeight || this.getCssVar('--header-height');

      return barHeight + headerHeight;
    }

    getHeaderOffset() {
      const bannerHeight =
        this.querySelector('.lx-product-sticky-banner__wrapper .lx-product-sticky-banner__top')?.offsetHeight || 0;
      return this.getHeaderBarOffset() + bannerHeight + this.getScrollOffset();
    }

    isBannerAtTop() {
      if (!this.classList.contains('is-visible')) return false;

      const topBar = this.querySelector('.lx-product-sticky-banner__top');
      if (!topBar) return false;

      const expectedTop = this.getHeaderBarOffset();
      const topBarTop = topBar.getBoundingClientRect().top;

      return topBarTop <= expectedTop + 8;
    }

    getHeaderElements() {
      return {
        bar: document.querySelector('.shopify-section.alp-announcement-bar-section'),
        header: document.querySelector('.shopify-section.alp-header-section'),
        section: document.querySelector('.shopify-section.lx-product-sticky-banner'),
      };
    }

    setHeaderHidden(hidden) {
      const nextHidden = Boolean(hidden);
      if (this._headerHidden === nextHidden) return;

      this._headerHidden = nextHidden;
      this.classList.toggle('is-header-hidden', nextHidden);
      document.documentElement.classList.add('lx-sticky-banner-header-transition');
      document.documentElement.classList.toggle('lx-sticky-banner-header-hidden', nextHidden);

      const { bar, header, section } = this.getHeaderElements();

      if (nextHidden) {
        bar?.style.setProperty('opacity', '0');
        bar?.style.setProperty('pointer-events', 'none');
        header?.style.setProperty('opacity', '0');
        header?.style.setProperty('pointer-events', 'none');
        section?.style.setProperty('top', '0');
      } else {
        bar?.style.removeProperty('opacity');
        bar?.style.removeProperty('pointer-events');
        header?.style.removeProperty('opacity');
        header?.style.removeProperty('pointer-events');
        section?.style.removeProperty('top');
      }
    }

    updateHeaderOnScrollDirection() {
      const currentScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      const scrollDelta = currentScrollY - this._lastScrollY;

      if (!this.classList.contains('is-visible')) {
        this.setHeaderHidden(false);
        this._lastScrollY = currentScrollY;
        return;
      }

      if (!this.isBannerAtTop()) {
        if (scrollDelta < -4) {
          this.setHeaderHidden(false);
        }
        this._lastScrollY = currentScrollY;
        return;
      }

      if (scrollDelta > 4) {
        this.setHeaderHidden(true);
      } else if (scrollDelta < -4) {
        this.setHeaderHidden(false);
      }

      this._lastScrollY = currentScrollY;
    }

    handleScroll() {
      const productDetail = this.productDetailEl || document.querySelector('[data-product-detail]');
      const mainContent = document.querySelector('main#MainContent');

      if (!productDetail || !mainContent) {
        this.classList.remove('is-visible');
        this.setHeaderHidden(false);
        return;
      }

      const productTop = productDetail.offsetTop + productDetail.offsetHeight;
      const mainBottom = mainContent.offsetTop + mainContent.offsetHeight;
      const shouldShow = window.scrollY > productTop + 0 && window.scrollY < mainBottom - 80;
      const shouldShowBottom = window.scrollY > productTop && window.scrollY < mainBottom - 20;

      this.classList.toggle('is-visible', shouldShow);
      this.classList.toggle('is-visible-bottom', shouldShowBottom);

      if (!shouldShow) {
        this.setHeaderHidden(false);
      }

      this.updateHeaderOnScrollDirection();
      this.updateActiveTab();
    }

    resolveTargetElement(tab) {
      const selector = tab?.dataset?.target;
      const targetId = tab?.dataset?.targetId;

      if (selector) {
        const bySelector = document.querySelector(selector);
        if (bySelector) return bySelector;
      }

      if (targetId) {
        const byHandle = document.querySelector(`[data-section-handle="${targetId}"]`);
        if (byHandle) return byHandle;

        if (window.CSS?.escape) {
          return document.querySelector(`#${CSS.escape(targetId)}`);
        }

        return document.getElementById(targetId);
      }

      return null;
    }

    getTargetTop(targetEl) {
      return targetEl.getBoundingClientRect().top + window.scrollY;
    }

    updateActiveTab() {
      const tabs = [
        ...this.querySelectorAll(
          '.lx-product-sticky-banner__tab[data-target], .lx-product-sticky-banner__tab[data-target-id]'
        ),
      ];
      if (!tabs.length) return;

      const scrollLine = window.scrollY + this.getHeaderOffset();
      let activeTab = null;

      const entries = tabs
        .map((tab) => {
          const targetEl = this.resolveTargetElement(tab);
          if (!targetEl) return null;
          return { tab, top: this.getTargetTop(targetEl) };
        })
        .filter(Boolean)
        .sort((a, b) => a.top - b.top);

      for (const entry of entries) {
        if (scrollLine >= entry.top) {
          activeTab = entry.tab;
        }
      }

      tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab === activeTab);
      });
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const targetEl = this.resolveTargetElement(tab);
      if (!targetEl) return;

      this.querySelectorAll('.lx-product-sticky-banner__tab').forEach((item) => {
        item.classList.toggle('is-active', item === tab);
      });

      const targetTop = this.getTargetTop(targetEl) - this.getHeaderOffset() + 2;
      window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
    }

    handleBannerQuantityChange() {
      if (this._syncingQuantity) return;
      this.syncQuantityToForm();
    }

    handleFormQuantityChange() {
      if (this._syncingQuantity) return;
      this.syncQuantityFromForm();
    }

    syncQuantityFromForm() {
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');

      if (!this.formQuantityEl || !this.bannerQuantityEl) return;

      this.copyQuantityRules(this.formQuantityEl, this.bannerQuantityEl);

      if (this.formQuantityEl.value !== this.bannerQuantityEl.value) {
        this._syncingQuantity = true;
        this.bannerQuantityEl.value = this.formQuantityEl.value;
        this._syncingQuantity = false;
      }

      this.bannerQuantityEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncQuantityToForm() {
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');

      if (!this.formQuantityEl || !this.bannerQuantityEl) return;
      if (this.formQuantityEl.value === this.bannerQuantityEl.value) return;

      this._syncingQuantity = true;
      this.formQuantityEl.value = this.bannerQuantityEl.value;
      this.formQuantityEl.dispatchEvent(new Event('change', { bubbles: true }));
      this._syncingQuantity = false;
    }

    copyQuantityRules(fromInput, toInput) {
      ['min', 'max', 'step', 'data-lx-qty-min', 'data-lx-qty-max', 'data-lx-qty-step'].forEach((attr) => {
        if (fromInput.hasAttribute(attr)) {
          toInput.setAttribute(attr, fromInput.getAttribute(attr));
        } else {
          toInput.removeAttribute(attr);
        }
      });
    }

    handleAddToCartClick() {
      if (!this.productFormEl || this.addToCartBtn?.disabled) return;

      this.syncQuantityToForm();
      this.addToCartBtn?.classList.add('is-loading');

      const submitButton = this.productFormEl.querySelector('[data-lx-add-to-cart-button], [type="submit"]');
      submitButton?.click();
    }

    handleFormLoadingChange() {
      setTimeout(() => {
        const isLoading = this.productFormEl?.classList.contains('loading');
        if (!isLoading) {
          this.addToCartBtn?.classList.remove('is-loading');
        }
      }, 200);
    }

    handleProductDetailUpdated(event) {
      const { html, variant } = event.detail || {};
      const sectionRoot = this.closest('[data-stid]');
      const sectionId = sectionRoot?.dataset?.stid;

      let nextBanner = null;
      if (sectionId && html) {
        nextBanner =
          html.querySelector(`[data-stid="${sectionId}"] lx-product-sticky-banner`) ||
          html.querySelector(`[data-stid="${sectionId}"] .lx-product-sticky-banner`);
      }
      nextBanner = nextBanner || html?.querySelector('lx-product-sticky-banner');

      if (nextBanner) {
        this.replaceElement('[data-product-sticky-banner-element="image"]', nextBanner);
        this.replaceElement('[data-product-sticky-banner-element="variant-title"]', nextBanner);
        this.replaceElement('[data-product-sticky-banner-element="price"]', nextBanner);
        this.replaceElement('[data-product-sticky-banner-element="quantity"]', nextBanner);
      } else if (variant) {
        this.updatePrice(variant);
        this.updateVariantTitle(variant);
      }

      if (variant) {
        this.dataset.variantId = String(variant.id);
        this.dataset.variantAvailable = String(variant.available);
        this.updateAddButton(variant);
        this.updateVariantTitle(variant);
      } else {
        this.updateAddButton(null);
      }

      this.bindQuantityListeners();
      this.syncQuantityFromForm();
    }

    replaceElement(selector, sourceRoot) {
      const currentEl = this.querySelector(selector);
      const nextEl = sourceRoot.querySelector(selector);
      if (!currentEl) return;

      if (!nextEl) {
        if (selector.includes('variant-title')) {
          currentEl.classList.add('hidden');
          currentEl.textContent = '';
        }
        return;
      }

      currentEl.innerHTML = nextEl.innerHTML;
      currentEl.className = nextEl.className;
    }

    updatePrice(variant) {
      const priceEl = this.querySelector('[data-product-sticky-banner-element="price"]');
      if (!priceEl || !variant) return;

      const currency = Shopify.currency.active;
      const language = `${Shopify.locale}-${Shopify.country}`;

      const priceNode = priceEl.querySelector('[data-product-price]');
      const compareNode = priceEl.querySelector('[data-product-compare-price]');

      if (priceNode && variant.price != null) {
        priceNode.textContent = (variant.price / 100).toLocaleString(language, {
          style: 'currency',
          currency,
        });
        priceNode.classList.toggle(
          'lx-product-sticky-banner__price-value--sale',
          variant.compare_at_price > variant.price
        );
      }

      if (compareNode) {
        if (variant.compare_at_price > variant.price) {
          compareNode.textContent = (variant.compare_at_price / 100).toLocaleString(language, {
            style: 'currency',
            currency,
          });
          compareNode.classList.remove('hidden');
        } else {
          compareNode.classList.add('hidden');
        }
      }
    }

    updateVariantTitle(variant) {
      const variantTitleEl = this.querySelector('[data-product-sticky-banner-element="variant-title"]');
      if (!variantTitleEl) return;

      const title = variant?.title?.trim();
      if (!title || title === 'Default Title') {
        variantTitleEl.classList.add('hidden');
        variantTitleEl.textContent = '';
        return;
      }

      variantTitleEl.textContent = title;
      variantTitleEl.classList.remove('hidden');
    }

    updateAddButton(variant) {
      const textEl = this.addToCartBtn?.querySelector('.lx-product-sticky-banner__add-to-cart-text');
      const available = Boolean(variant?.available);

      if (!this.addToCartBtn) return;

      this.addToCartBtn.disabled = !available;
      if (available) {
        this.addToCartBtn.removeAttribute('aria-disabled');
      } else {
        this.addToCartBtn.setAttribute('aria-disabled', 'true');
      }

      if (textEl) {
        textEl.textContent = available
          ? window.variantStrings?.addToCart || 'Add to cart'
          : window.variantStrings?.soldOut || 'Sold out';
      }
    }
  }

  if (!customElements.get('lx-product-sticky-banner')) {
    customElements.define('lx-product-sticky-banner', LXProductStickyBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
